import React from "react";


function Video(props){

    return <iframe width="100%" height="100%" src={`${props.src}?mute=1`} title={props.title} className="Item-video"></iframe>
}

export default Video;